import config from '~/config';

export const CREATE_USER_ENDPOINT = '/public/create-user';
export const SIGNUP_ENDPOINT = '/signup/create-user';
export const CONFIRM_EMAIL_ENDPOINT = '/signup/confirm-email';
export const SSO_API_URL = `${config.USER_MANAGEMENT_URL}/api/v1/`;
export const LOGOUT_URL = '/auth/logout';

export const DEFAULT_TIMEOUT = 5000;

export const TIMEOUT_ERROR = 'TIMEOUT_ERROR';
